import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CategoryNewsList from './category_news_list';
import CategoryNewsDetail from './category_news_detail';

class Category extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <CategoryNewsList/>;
    }else{
      if(params.id===undefined){
        view = <CategoryNewsDetail/>;
      }else{
        view = <CategoryNewsDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

Category.contextTypes = {
  router: PropTypes.object
};

export default Category;
